import React from "react";
import ReactJson from "react-json-view";
import styles from "./DisplayData.module.scss";
import { Button } from "@yoti/ui-kit-components-react/button";

const isObjectEmpty = (obj) =>
  obj === undefined ||
  obj === null ||
  Object.keys(obj).filter((key) => key !== "description").length === 0;

const getNumberOfDevices = (data) => {
  const numCameraDevices = data?.metadata?.camera?.length || 0;

  const numAccelerometers = isObjectEmpty(
    data?.metadata?.accelerometer?.accelerometer
  )
    ? 0
    : 1;
  const numDeviceMotion = isObjectEmpty(
    data?.metadata?.accelerometer?.deviceMotion
  )
    ? 0
    : 1;

  const numGyroscopes = isObjectEmpty(data?.metadata?.gyroscope?.gyroscope)
    ? 0
    : 1;
  const numDeviceOrientation = isObjectEmpty(
    data?.metadata?.gyroscope?.deviceorientation
  )
    ? 0
    : 1;

  const numGPS = data?.metadata?.gps ? 1 : 0;

  const numUserVerifyDevices = data?.metadata?.userVerify ? 1 : 0;

  return {
    numCamera: numCameraDevices,
    numAccelerometers: numAccelerometers + numDeviceMotion,
    numGyroscopes: numGyroscopes + numDeviceOrientation,
    numGPS,
    numUserVerify: numUserVerifyDevices,
  };
};

export const DisplayData = ({ data }) => {
  const { numCamera, numAccelerometers, numGyroscopes, numGPS, numUserVerify } =
    getNumberOfDevices(data);

  const onDownloadData = () => {
    if (!data) return;

    const jsonStr = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonStr], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "data.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    data && (
      <div className={styles.displaydata}>
        <div>
          <p>
            Found <strong>{numCamera}</strong> video device(s),{" "}
            <strong>{numAccelerometers}</strong> accelerometer(s),{" "}
            <strong>{numGyroscopes}</strong> gyroscope(s),{" "}
            <strong>{numGPS}</strong> GPS device(s), and{" "}
            <strong>{numUserVerify}</strong> user verification device(s).
          </p>
          <p>Data collected:</p>
        </div>
        <div className={styles.displaydata__data}>
          <ReactJson
            src={data}
            collapsed={1}
            displayDataTypes={false}
            enableClipboard={true}
            indentWidth={2}
          />
        </div>
        <div>
          <Button onClick={onDownloadData}>Download data</Button>
        </div>
      </div>
    )
  );
};
